export default __webpack_public_path__ + "static/media/run-chimp.1768530c.png";